export var EASE_IN_OUT = 'cubic-bezier(0.5, 0, 0.5, 0.1)';
export var EASE_IN = 'cubic-bezier(0.17, 0.84, 0.44, 0.1)';
export var EASE_OUT = 'cubic-bezier(0.18, 0.66, 0.6, 0.82)';
export var LINEAR = 'cubic-bezier(0, 0, 0.1, 0.1)';
export var EASE_OUT_CUBIC = 'cubic-bezier(0.33, 1, 0.68, 1)';
export var EASE_IN_CUBIC = 'cubic-bezier(0.32, 0, 0.67, 0)';
export var EASE_IN_OUT_CUBIC = 'cubic-bezier(0.65, 0, 0.35, 1)';
